import { INoesisV2Model } from './model';

const views = (self: INoesisV2Model) => ({
  getThread(threadId: string) {
    return self.threads.getById(threadId);
  },

  getThreadMessages(threadId: string) {
    const thread = self.threads.getById(threadId);
    return thread?.messages || [];
  },

  getThreadError(threadId: string) {
    const thread = self.threads.getById(threadId);
    return thread ? thread.error : null;
  },

  isThreadLoading(threadId: string) {
    const thread = self.threads.getById(threadId);
    return thread ? thread.isFetching : false;
  }
});

export default views;
